import {
  utils,
} from '@ama-sdk/core';
import {
  Flight,
  FlightItem,
} from '@dapi/sdk';
import {
  createAir,
  createAlternativeOffer,
  createFlightItem,
  MockFlightItem,
  todayPlusNdays,
} from '@dapi/sdk/spec';
import {
  cabin,
  cphOslFlightItem,
  createCustomFlight,
} from './flights';

export const alternativeOfferForUnOnly1 = createAlternativeOffer({
  template: {
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          originLocationCode: 'CPH',
          destinationLocationCode: 'OSL',
          duration: 3900,
          flights: [{
            ...cphOslFlightItem,
            id: 'FLT1'
          }]
        }
      }
    })
  }
});

export const alternativeOfferForUnOnly2 = createAlternativeOffer({
  template: {
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          originLocationCode: 'CPH',
          destinationLocationCode: 'OSL',
          duration: 4200,
          flights: [{
            ...cphOslFlightItem,
            id: 'FLT2'
          }]
        }
      }
    })
  }
});

export const alternativeOfferForUnOnly3 = createAlternativeOffer({
  template: {
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          originLocationCode: 'CPH',
          destinationLocationCode: 'OSL',
          duration: 4500,
          flights: [{
            ...cphOslFlightItem,
            id: 'FLT3'
          }]
        }
      }
    })
  }
});

export const alternativeOfferForUnOnly4 = createAlternativeOffer({
  template: {
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          originLocationCode: 'CPH',
          destinationLocationCode: 'OSL',
          duration: 4200,
          flights: [{
            ...cphOslFlightItem,
            id: 'FLT4'
          }]
        }
      }
    })
  }
});

export const alternativeOfferForUnOnly5 = createAlternativeOffer({
  template: {
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          originLocationCode: 'CPH',
          destinationLocationCode: 'OSL',
          duration: 4200,
          flights: [{
            ...cphOslFlightItem,
            id: 'FLT5'
          }]
        }
      }
    })
  }
});

const helTkuAlternativeFlight1: Flight = {
  ...createCustomFlight(),
  operatingAirlineName: 'FINNAIR',
  operatingAirlineCode: 'AY',
  marketingFlightNumber: '649',
  duration: 3900
};
const helTkuAlternativeFlightItem1: MockFlightItem = createFlightItem({
  template: {
    id: 'ST3',
    flight: helTkuAlternativeFlight1,
    cabin,
    bookingClass: 'Y',
    statusCode: 'TK'
  }
});

const tkuHekAlternativeFlight1: Flight = {
  ...createCustomFlight(),
  operatingAirlineName: 'FINNAIR',
  operatingAirlineCode: 'AY',
  marketingFlightNumber: '649',
  duration: 3900
};
const tkuHelAlternativeFlightItem1: MockFlightItem = createFlightItem({
  template: {
    id: 'ST3',
    flight: tkuHekAlternativeFlight1,
    cabin,
    bookingClass: 'Y',
    statusCode: 'TK'
  }
});

const helTkuAlternativeFlight2: Flight = {
  ...createCustomFlight('HEL', 'TKU', 2),
  operatingAirlineName: 'FINNAIR',
  operatingAirlineCode: 'AY',
  marketingFlightNumber: '649',
  duration: 3900
};
const helTkuAlternativeFlightItem2: MockFlightItem = createFlightItem({
  template: {
    id: 'ST3',
    flight: helTkuAlternativeFlight2,
    cabin,
    bookingClass: 'Y',
    statusCode: 'TK'
  }
});

const tkuHelAlternativeFlight2: Flight = {
  ...createCustomFlight('TKU', 'HEL', 2),
  operatingAirlineName: 'FINNAIR',
  operatingAirlineCode: 'AY',
  marketingFlightNumber: '649',
  duration: 3900
};
const tkuHelAlternativeFlightItem2: MockFlightItem = createFlightItem({
  template: {
    id: 'ST3',
    flight: tkuHelAlternativeFlight2,
    cabin,
    bookingClass: 'Y',
    statusCode: 'TK'
  }
});

const helTkuAlternativeFlight3: Flight = {
  ...createCustomFlight('HEL', 'TKU', 3),
  operatingAirlineName: 'FINNAIR',
  operatingAirlineCode: 'AY',
  marketingFlightNumber: '649',
  duration: 3900
};
const helTkuAlternativeFlightItem3: MockFlightItem = createFlightItem({
  template: {
    id: 'ST3',
    flight: helTkuAlternativeFlight3,
    cabin,
    bookingClass: 'Y',
    statusCode: 'TK'
  }
});

const tkuHelAlternativeFlight3: Flight = {
  ...createCustomFlight('TKU', 'HEL', 3),
  operatingAirlineName: 'FINNAIR',
  operatingAirlineCode: 'AY',
  marketingFlightNumber: '649',
  duration: 3900
};
const tkuHelAlternativeFlightItem3: MockFlightItem = createFlightItem({
  template: {
    id: 'ST3',
    flight: tkuHelAlternativeFlight3,
    cabin,
    bookingClass: 'Y',
    statusCode: 'TK'
  }
});

export const alternativeOfferHelTku1 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-1',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 3900,
          flights: [{
            ...helTkuAlternativeFlightItem1,
            id: 'FLT1'
          }]
        }
      }
    })
  }
});

export const alternativeOfferHelTku2 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-2',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 4200,
          flights: [{
            ...helTkuAlternativeFlightItem2,
            id: 'FLT2'
          }]
        }
      }
    })
  }
});

export const alternativeOfferHelTku3 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-3',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 4500,
          flights: [{
            ...helTkuAlternativeFlightItem3,
            id: 'FLT3'
          }]
        }
      }
    })
  }
});

export const alternativeOfferTkuHel1 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-1',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          originLocationCode: 'TKU',
          destinationLocationCode: 'HEL',
          duration: 3900,
          flights: [{
            ...tkuHelAlternativeFlightItem1,
            id: 'FLT1'
          }]
        }
      }
    })
  }
});

export const alternativeOfferTkuHel2 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-2',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          originLocationCode: 'TKU',
          destinationLocationCode: 'HEL',
          duration: 4200,
          flights: [{
            ...tkuHelAlternativeFlightItem2,
            id: 'FLT2'
          }]
        }
      }
    })
  }
});

export const alternativeOfferTkuHel3 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-3',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          originLocationCode: 'TKU',
          destinationLocationCode: 'HEL',
          duration: 4500,
          flights: [{
            ...tkuHelAlternativeFlightItem3,
            id: 'FLT3'
          }]
        }
      }
    })
  }
});

/**
 * Alternative Flight from CPH to OSL on the same day
 */
const cphOslAlternativeFlight1: Flight = {
  ...createCustomFlight('CPH', 'OSL', 1, '0E', '12:30', '16:55'),
  marketingAirline: 'AMADEUS PRESALES 0E',
  marketingAirlineCode: '0E',
  operatingAirline: 'AMADEUS PRESALES 0E',
  operatingAirlineCode: '0E',
  marketingFlightNumber: '635',
  duration: 6300,
  aircraft: 'BOEING 737-700',
  aircraftCode: '73G'
};
const cphOslAlternativeFlightItem1: FlightItem = {
  bookingClass: 'J',
  cabin,
  flight: cphOslAlternativeFlight1,
  id: 'FLT1'
};

/**
 * Alternative Flight from OSL to LHR on the same day
 */
const oslLhrAlternativeFlight1: Flight = {
  ...createCustomFlight('OSL', 'LHR', 1, '0E', '12:30', '16:55'),
  marketingAirline: 'AMADEUS PRESALES 0E',
  marketingAirlineCode: '0E',
  operatingAirline: 'AMADEUS PRESALES 0E',
  operatingAirlineCode: '0E',
  marketingFlightNumber: '635',
  duration: 6300,
  aircraft: 'BOEING 737-700',
  aircraftCode: '73G'
};
const oslLhrAlternativeFlightItem1: FlightItem = {
  bookingClass: 'J',
  cabin,
  flight: oslLhrAlternativeFlight1,
  id: 'FLT2'
};

/**
 * Alternative Flight from OSL to LHR on the same day
 */
const oslLhrAlternativeFlight2: Flight = {
  ...createCustomFlight('OSL', 'LHR', 1, '0E', '14:30', '16:55'),
  marketingAirline: 'AMADEUS PRESALES 0E',
  marketingAirlineCode: '0E',
  operatingAirline: 'AMADEUS PRESALES 0E',
  operatingAirlineCode: '0E',
  marketingFlightNumber: '635',
  duration: 6300,
  aircraft: 'BOEING 737-700',
  aircraftCode: '73G'
};
const oslLhrAlternativeFlightItem2: FlightItem = {
  bookingClass: 'J',
  cabin,
  flight: oslLhrAlternativeFlight2,
  id: 'FLT2'
};

/**
 * Alternative Flight from CPH to OSL for the next day
 */
const cplOshAlternativeFlight2: Flight = {
  ...createCustomFlight('CPH', 'OSL', 2, '0E'),
  marketingAirline: 'AMADEUS PRESALES 0E',
  marketingAirlineCode: '0E',
  operatingAirline: 'AMADEUS PRESALES 0E',
  operatingAirlineCode: '0E',
  marketingFlightNumber: '635',
  duration: 6300,
  aircraft: 'BOEING 737-700',
  aircraftCode: '73G'
};
const cphOslAlternativeFlightItem2: FlightItem = {
  bookingClass: 'J',
  cabin,
  flight: cplOshAlternativeFlight2,
  id: 'FLT2'
};

export const alternativeOfferCphOsl1 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-1',
    type: 'alternative-offers',
    air: {
      bound: {
        originLocationCode: 'CPH',
        destinationLocationCode: 'OSL',
        duration: 6300,
        flights: [cphOslAlternativeFlightItem1]
      }
    }
  }
});

export const alternativeOfferOslLhr1 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-1',
    type: 'alternative-offers',
    air: {
      bound: {
        originLocationCode: 'OSL',
        destinationLocationCode: 'LHR',
        duration: 6300,
        flights: [oslLhrAlternativeFlightItem1]
      }
    }
  }
});

export const alternativeOfferOslLhr2 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-2',
    type: 'alternative-offers',
    air: {
      bound: {
        originLocationCode: 'OSL',
        destinationLocationCode: 'LHR',
        duration: 6300,
        flights: [oslLhrAlternativeFlightItem2]
      }
    }
  }
});

export const alternativeOfferCphOsl2 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-2',
    type: 'alternative-offers',
    air: {
      bound: {
        originLocationCode: 'CPH',
        destinationLocationCode: 'OSL',
        duration: 6300,
        flights: [cphOslAlternativeFlightItem2]
      }
    }
  }
});

/**
 * Alternative Flight from OSL to CPH on the same day
 */
const oslCphAlternativeFlight1: Flight = {
  ...createCustomFlight('OSL', 'CPH', 15, '0E', '12:30', '16:55'),
  marketingAirline: 'AMADEUS PRESALES 0E',
  marketingAirlineCode: '0E',
  operatingAirline: 'AMADEUS PRESALES 0E',
  operatingAirlineCode: '0E',
  marketingFlightNumber: '635',
  duration: 6300,
  aircraft: 'BOEING 737-700',
  aircraftCode: '73G'
};
const oslCphAlternativeFlightItem1: FlightItem = {
  bookingClass: 'J',
  cabin,
  flight: oslCphAlternativeFlight1,
  id: 'FLT1'
};

/**
 * Alternative Flight from OSL to CPH for the next day
 */
const oslCphAlternativeFlight2: Flight = {
  ...createCustomFlight('OSL', 'CPH', 16, '0E'),
  marketingAirline: 'AMADEUS PRESALES 0E',
  marketingAirlineCode: '0E',
  operatingAirline: 'AMADEUS PRESALES 0E',
  operatingAirlineCode: '0E',
  marketingFlightNumber: '635',
  duration: 6300,
  aircraft: 'BOEING 737-700',
  aircraftCode: '73G'
};
const oslCphAlternativeFlightItem2: FlightItem = {
  bookingClass: 'J',
  cabin,
  flight: oslCphAlternativeFlight2,
  id: 'FLT2'
};

export const alternativeOfferOslCph1 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-1',
    type: 'alternative-offers',
    air: {
      bound: {
        originLocationCode: 'CPH',
        destinationLocationCode: 'OSL',
        duration: 6300,
        flights: [oslCphAlternativeFlightItem1]
      }
    }
  }
});

export const alternativeOfferOslCph2 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-2',
    type: 'alternative-offers',
    air: {
      bound: {
        originLocationCode: 'CPH',
        destinationLocationCode: 'OSL',
        duration: 6300,
        flights: [oslCphAlternativeFlightItem2]
      }
    }
  }
});

const inboundhelTkuAlternativeFlight1: Flight = {
  ...createCustomFlight('HEL', 'ARN', 0, 'AY', '16:10', '16:10', '2', '2'),
  operatingAirlineName: 'FINNAIR',
  marketingFlightNumber: '813',
  duration: 3600
};

const inboundhelTkuAlternativeFlight2: Flight = {
  ...createCustomFlight('ARN', 'TKU', 0, 'SK', '17:10', '19:05', '5', '1'),
  marketingFlightNumber: '4236',
  duration: 3300,
  aircraftCode: 'AT7'
};

const inboundhelTkuAlternativeFlight3: Flight = {
  ...createCustomFlight('HEL', 'ARN', 0, 'AY', '12:20', '12:20', '2', '2'),
  marketingFlightNumber: '807',
  duration: 3600,
  aircraftCode: '319'
};

const inboundhelTkuAlternativeFlight4: Flight = {
  ...createCustomFlight('ARN', 'TKU', 0, 'SK', '14:00', '15:55', '5', '1'),
  marketingFlightNumber: '2728',
  duration: 3300,
  aircraftCode: 'AT7'
};

const inboundhelTkuAlternativeFlight5: Flight = {
  ...createCustomFlight('HEL', 'TKU', 0, 'AY', '13:55', '14:30', '2', '1'),
  marketingFlightNumber: '223',
  duration: 2100,
  aircraftCode: 'AT7'
};

const inboundhelTkuAlternativeFlight6: Flight = {
  ...createCustomFlight('HEL', 'TKU', 0, 'AY', '16:15', '16:50', '2', '1'),
  marketingFlightNumber: '225',
  duration: 2100,
  aircraftCode: 'AT7'
};
const inboundhelTkuAlternativeFlight7: Flight = {
  ...createCustomFlight('HEL', 'TKU', 0, 'AY', '20:00', '20:35', '2', '1'),
  marketingFlightNumber: '633',
  duration: 2100,
  aircraftCode: 'AT7'
};

const inboundhelTkuAlternativeFlight8: Flight = {
  ...createCustomFlight('HEL', 'TKU', 1, 'AY', '16:16', '16:51', '2', '1'),
  marketingFlightNumber: '225',
  duration: 2100,
  aircraftCode: 'AT7'
};

const inboundhelTkuAlternativeFlight9: Flight = {
  ...createCustomFlight('HEL', 'ARN', 2, 'AY', '14:05', '14:00', '2', '2'),
  marketingFlightNumber: '809',
  duration: 3300,
  aircraftCode: '32B'
};

const inboundhelTkuAlternativeFlight10: Flight = {
  ...createCustomFlight('ARN', 'TKU', 2, 'SK', '15:30', '17:25', '5', '1'),
  marketingFlightNumber: '4234',
  duration: 3300,
  aircraftCode: 'AT7'
};

const inboundhelTkuAlternativeFlight11: Flight = {
  ...createCustomFlight('HEL', 'TKU', 2, 'AY', '13:35', '14:30', '2', '1'),
  marketingFlightNumber: '223',
  duration: 2100,
  aircraftCode: 'AT7'
};

const inboundhelTkuAlternativeFlight12: Flight = {
  ...createCustomFlight('HEL', 'TKU', 2, 'AY', '16:15', '16:50', '2', '1'),
  marketingFlightNumber: '225',
  duration: 2100,
  aircraftCode: 'AT7'
};

const inboundhelTkuAlternativeFlight13: Flight = {
  ...createCustomFlight('HEL', 'TKU', 2, 'AY', '20:00', '20:35', '2', '1'),
  marketingFlightNumber: '633',
  duration: 2100,
  aircraftCode: 'AT7'
};

const inboundhelTkuAlternativeFlight14: Flight = {
  ...createCustomFlight('HEL', 'TKU', 2, 'AY', '23:45', '00:25', '2', '1'),
  marketingFlightNumber: '229',
  duration: 2400,
  aircraftCode: 'AT7'
};

const inboundhelTkuAlternativeFlight15: Flight = {
  ...createCustomFlight('HEL', 'TKU', 3, 'AY', '08:10', '09:55', '2', '1'),
  marketingFlightNumber: '649',
  duration: 6300,
  aircraftCode: 'AT7',
  stops: [
    {
      locationCode: 'MHQ',
      duration: 1200,
      isChangeOfGauge: false,
      arrivalDateTime: new utils.DateTime(todayPlusNdays('09:05', 3)),
      departureDateTime: new utils.DateTime(todayPlusNdays('09:25', 3)),
      aircraftCode: 'AT7'
    }
  ]
};

const inboundhelTkuAlternativeFlight16: Flight = {
  ...createCustomFlight('HEL', 'ARN', 3, 'AY', '16:10', '17:10', '2', '2'),
  marketingFlightNumber: '813',
  duration: 3600,
  aircraftCode: '320'
};

const inboundhelTkuAlternativeFlight17: Flight = {
  ...createCustomFlight('ARN', 'TKU', 3, 'SK', '17:10', '19:05', '5', '1'),
  marketingFlightNumber: '4236',
  duration: 3300,
  aircraftCode: 'AT7'
};

const inboundhelTkuAlternativeFlight18: Flight = {
  ...createCustomFlight('ARN', 'TKU', 3, 'W2', '17:20', '19:15', '2', '0'),
  marketingFlightNumber: '2104',
  duration: 3300,
  aircraftCode: 'SF3'
};

const inboundhelTkuAlternativeFlight19: Flight = {
  ...createCustomFlight('HEL', 'TKU', 3, 'AY', '13:55', '14:30', '2', '1'),
  marketingFlightNumber: '223',
  duration: 2100,
  aircraftCode: 'AT7'
};

const inboundhelTkuAlternativeFlight20: Flight = {
  ...createCustomFlight('HEL', 'TKU', 3, 'AY', '20:00', '20:35', '2', '1'),
  marketingFlightNumber: '633',
  duration: 2100,
  aircraftCode: 'AT7'
};

const inboundhelTkuAlternativeFlight21: Flight = {
  ...createCustomFlight('HEL', 'ARN', 4, 'AY', '16:10', '16:10', '2', '2'),
  marketingFlightNumber: '813',
  duration: 3600,
  aircraftCode: '320'
};

const inboundhelTkuAlternativeFlight22: Flight = {
  ...createCustomFlight('ARN', 'TKU', 4, 'SK', '17:10', '19:05', '5', '1'),
  marketingFlightNumber: '4236',
  duration: 3300,
  aircraftCode: 'AT7'
};

const inboundhelTkuAlternativeFlight23: Flight = {
  ...createCustomFlight('HEL', 'TKU', 4, 'AY', '16:15', '16:50', '2', '1'),
  marketingFlightNumber: '225',
  duration: 2100,
  aircraftCode: 'AT7'
};

const inboundhelTkuAlternativeFlight24: Flight = {
  ...createCustomFlight('HEL', 'TKU', 4, 'AY', '20:00', '20:35', '2', '1'),
  marketingFlightNumber: '633',
  duration: 2100,
  aircraftCode: 'AT7'
};

const inboundhelTkuAlternativeFlight25: Flight = {
  ...createCustomFlight('HEL', 'TKU', 4, 'AY', '08:10', '09:55', '2', '1'),
  marketingFlightNumber: '649',
  duration: 6300,
  aircraftCode: 'AT7',
  stops: [
    {
      locationCode: 'MHQ',
      duration: 1200,
      isChangeOfGauge: false,
      arrivalDateTime: new utils.DateTime(todayPlusNdays('09:05', 5)),
      departureDateTime: new utils.DateTime(todayPlusNdays('09:25', 5)),
      aircraftCode: 'AT7'
    }
  ]
};

const inboundhelTkuAlternativeFlightItem1: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT1',
    flight: inboundhelTkuAlternativeFlight1
  }
});

const inboundhelTkuAlternativeFlightItem2: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT2',
    flight: inboundhelTkuAlternativeFlight2
  }
});

const inboundhelTkuAlternativeFlightItem3: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT3',
    flight: inboundhelTkuAlternativeFlight3
  }
});

const inboundhelTkuAlternativeFlightItem4: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT4',
    flight: inboundhelTkuAlternativeFlight4
  }
});

const inboundhelTkuAlternativeFlightItem5: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT5',
    flight: inboundhelTkuAlternativeFlight5
  }
});

const inboundhelTkuAlternativeFlightItem6: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT6',
    flight: inboundhelTkuAlternativeFlight6
  }
});

const inboundhelTkuAlternativeFlightItem7: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT7',
    flight: inboundhelTkuAlternativeFlight7
  }
});

const inboundhelTkuAlternativeFlightItem8: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT8',
    flight: inboundhelTkuAlternativeFlight8
  }
});

const inboundhelTkuAlternativeFlightItem9: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT9',
    flight: inboundhelTkuAlternativeFlight9
  }
});

const inboundhelTkuAlternativeFlightItem10: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT10',
    flight: inboundhelTkuAlternativeFlight10
  }
});

const inboundhelTkuAlternativeFlightItem11: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT11',
    flight: inboundhelTkuAlternativeFlight11
  }
});

const inboundhelTkuAlternativeFlightItem12: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT12',
    flight: inboundhelTkuAlternativeFlight12
  }
});

const inboundhelTkuAlternativeFlightItem13: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT13',
    flight: inboundhelTkuAlternativeFlight13
  }
});

const inboundhelTkuAlternativeFlightItem14: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT14',
    flight: inboundhelTkuAlternativeFlight14
  }
});

const inboundhelTkuAlternativeFlightItem15: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT15',
    flight: inboundhelTkuAlternativeFlight15
  }
});

const inboundhelTkuAlternativeFlightItem16: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT16',
    flight: inboundhelTkuAlternativeFlight16
  }
});

const inboundhelTkuAlternativeFlightItem17: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT17',
    flight: inboundhelTkuAlternativeFlight17
  }
});

const inboundhelTkuAlternativeFlightItem18: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT18',
    flight: inboundhelTkuAlternativeFlight18
  }
});

const inboundhelTkuAlternativeFlightItem19: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT19',
    flight: inboundhelTkuAlternativeFlight19
  }
});

const inboundhelTkuAlternativeFlightItem20: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT20',
    flight: inboundhelTkuAlternativeFlight20
  }
});

const inboundhelTkuAlternativeFlightItem21: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT21',
    flight: inboundhelTkuAlternativeFlight21
  }
});

const inboundhelTkuAlternativeFlightItem22: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT22',
    flight: inboundhelTkuAlternativeFlight22
  }
});

const inboundhelTkuAlternativeFlightItem23: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT23',
    flight: inboundhelTkuAlternativeFlight23
  }
});

const inboundhelTkuAlternativeFlightItem24: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT24',
    flight: inboundhelTkuAlternativeFlight24
  }
});

const inboundhelTkuAlternativeFlightItem25: MockFlightItem = createFlightItem({
  template: {
    id: 'FLT25',
    flight: inboundhelTkuAlternativeFlight25
  }
});

export const inboundAlternativeOfferHelTku1 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-1',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 10_500,
          flights: [inboundhelTkuAlternativeFlightItem1, inboundhelTkuAlternativeFlightItem2]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku2 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-2',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          originLocationCode: 'HEL',
          destinationLocationCode: 'TKU',
          duration: 12_900,
          flights: [inboundhelTkuAlternativeFlightItem3, inboundhelTkuAlternativeFlightItem4]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku3 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-3',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 2100,
          flights: [inboundhelTkuAlternativeFlightItem5]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku4 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-4',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 2100,
          flights: [inboundhelTkuAlternativeFlightItem6]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku5 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-5',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 2100,
          flights: [inboundhelTkuAlternativeFlightItem7]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku6 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-6',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 2100,
          flights: [inboundhelTkuAlternativeFlightItem8]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku7 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-7',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 12_000,
          flights: [inboundhelTkuAlternativeFlightItem9, inboundhelTkuAlternativeFlightItem10]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku8 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-8',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 2100,
          flights: [inboundhelTkuAlternativeFlightItem11]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku9 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-9',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 2100,
          flights: [inboundhelTkuAlternativeFlightItem12]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku10 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-10',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 2100,
          flights: [inboundhelTkuAlternativeFlightItem13]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku11 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-11',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 2400,
          flights: [inboundhelTkuAlternativeFlightItem14]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku12 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-12',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 6300,
          flights: [inboundhelTkuAlternativeFlightItem15]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku13 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-13',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 10_500,
          flights: [inboundhelTkuAlternativeFlightItem16, inboundhelTkuAlternativeFlightItem17]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku14 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-14',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 11_100,
          flights: [inboundhelTkuAlternativeFlightItem16, inboundhelTkuAlternativeFlightItem18]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku15 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-15',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 2100,
          flights: [inboundhelTkuAlternativeFlightItem19]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku16 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-16',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 2100,
          flights: [inboundhelTkuAlternativeFlightItem20]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku17 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-17',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 10_500,
          flights: [inboundhelTkuAlternativeFlightItem21, inboundhelTkuAlternativeFlightItem22]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku18 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-18',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 2100,
          flights: [inboundhelTkuAlternativeFlightItem23]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku19 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-19',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 2100,
          flights: [inboundhelTkuAlternativeFlightItem24]
        }
      }
    })
  }
});

export const inboundAlternativeOfferHelTku20 = createAlternativeOffer({
  template: {
    id: 'alternative-offer-20',
    type: 'alternative-offers',
    air: createAir({
      template: {
        bound: {
          ...inboundAlternativeOfferHelTku1.air.bound,
          duration: 6300,
          flights: [inboundhelTkuAlternativeFlightItem25]
        }
      }
    })
  }
});
